var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArroeMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18075_4252",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 28,
    height: 28,
    transform: "rotate(-180 28 28)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18075_4252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9976 2.91732C15.5306 2.91732 16.9716 3.20821 18.3204 3.78998C19.6693 4.37176 20.8426 5.1613 21.8403 6.15861C22.838 7.15591 23.6279 8.32871 24.21 9.67698C24.792 11.0253 25.083 12.4658 25.083 13.9986C25.083 15.5316 24.7921 16.9725 24.2103 18.3214C23.6286 19.6703 22.839 20.8435 21.8417 21.8412C20.8444 22.8389 19.6716 23.6289 18.3233 24.211C16.9751 24.793 15.5345 25.084 14.0017 25.084C12.4687 25.084 11.0278 24.7931 9.67892 24.2113C8.33006 23.6295 7.15679 22.84 6.15909 21.8427C5.1614 20.8454 4.37147 19.6726 3.7893 18.3243C3.20733 16.976 2.91634 15.5355 2.91634 14.0027C2.91634 12.4697 3.20723 11.0288 3.78901 9.6799C4.37078 8.33104 5.16033 7.15776 6.15763 6.16007C7.15494 5.16237 8.32773 4.37244 9.67601 3.79028C11.0243 3.2083 12.4648 2.91732 13.9976 2.91732ZM13.0596 13.1257L14.6145 11.5708C14.7759 11.4092 14.8547 11.208 14.851 10.9673C14.8474 10.7266 14.7647 10.5254 14.6031 10.3639C14.4416 10.2023 14.2379 10.1215 13.9921 10.1215C13.7463 10.1215 13.5439 10.2023 13.3848 10.3639L10.4863 13.2624C10.2753 13.4734 10.1698 13.7195 10.1698 14.0007C10.1698 14.2818 10.2753 14.5279 10.4863 14.7389L13.3962 17.6488C13.5578 17.8102 13.759 17.8909 13.9997 17.8909C14.2404 17.8909 14.4416 17.8102 14.6031 17.6488C14.7647 17.4872 14.8455 17.2836 14.8455 17.0378C14.8455 16.792 14.7647 16.5896 14.6031 16.4305L13.0596 14.8757H17.4997C17.7476 14.8757 17.9554 14.7917 18.123 14.6239C18.2908 14.4561 18.3747 14.2483 18.3747 14.0004C18.3747 13.7522 18.2908 13.5445 18.123 13.3771C17.9554 13.2095 17.7476 13.1257 17.4997 13.1257H13.0596Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArroeMoney);
export default __webpack_public_path__ + "static/media/back_arroe_money.b037c51d604c9fd12cebcacd2c69333e.svg";
export { ForwardRef as ReactComponent };